


  (function () {
    var loadScript = function (url, callback) {
      var script = document.createElement("script");
      script.type = "text/javascript";
      // If the browser is Internet Explorer.
      if (script.readyState) {
        script.onreadystatechange = function () {
          if (script.readyState == "loaded" || script.readyState == "complete") {
            script.onreadystatechange = null;
            callback();
          }
        };
        // For any other browser.
      } else {
        script.onload = function () {
          callback();
        };
      }
      script.src = url;
      document.getElementsByTagName("head")[0].appendChild(script);
    };
   
    var hidescript = function ($) {
      hidebannermethod();
    
       $("body").on('click', "button", function(r){
          debugger;
         setTimeout(function(){
               //window.location.reload();
           window.location.href=window.location.href;
               //hidebannermethod();
           },200);
       });
       $("body").on('click', ".diamond-proxy-product-wrapper", function(r){
          debugger;
         hidebannermethod();
       });

      function hidebannermethod(){
        var IsHide=false;
          var stoneType = GetParameterValuesSingleDecode("stoneType");
        var id = GetParameterValuesSingleDecode("id");
        
          debugger;
          if (stoneType != null && stoneType != undefined && stoneType != "") {
           debugger;
            if(stoneType=="diamond"){
              IsHide=true;
            }
          }
          else if (id != null && id != undefined && id != "") {
             debugger;
                IsHide=true;
            }
          if(IsHide){
            $("div.productgrid--masthead").hide();
            $("div.mobile-banner-diamond").hide();
            $("div.custom-collection-banner").hide();
          }
          else{
            $("div.productgrid--masthead").show();
            $("div.mobile-banner-diamond").show();
            $("div.custom-collection-banner").show();
            //window.location.reload();
          }
      }
      
      function GetParameterValuesSingleDecode(param) {
        var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < url.length; i++) {
          var urlparam = url[i].split('=');
          if (urlparam[0] == param) {
            return urlparam[1];
          }
        }
      }
      
    };
    if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {

      loadScript('//code.jquery.com/jquery-2.2.4.min.js', function () {
        jQuery224 = jQuery.noConflict(true);
        hidescript(jQuery224);
      });
    } else {

      hidescript(jQuery);
    }
  })();
